<div class="template-crud-com-abas">
    <!-- <div class="row">
        <div class="col-md-8">
            <h3>{{titulo}} - <small>{{acaoGeral?.descricao}}</small></h3>
            <p>{{subtitulo}}</p>
        </div>
        <div class="col-md-4 text-right pt-2">

        </div>
    </div> -->
    <mat-progress-bar color="primary" mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
    <section id="main-content">
        <div>
            <ng-template [ngComponentOutlet]="componenteFiltro.component" [ndcDynamicInputs]="componenteFiltro.inputs"
                [ndcDynamicOutputs]="componenteFiltro.outputs">
            </ng-template>
        </div>
        <div>
            <dynamic-component [hidden]="true"></dynamic-component>
            <mat-tab-group mat-align-tabs="start" class="dynamic-tabs" dynamicHeight="true"
                [class]="arrayAbas.length > 0 ? 'with-details' : ''" [selectedIndex]="tabIndex"
                (selectedIndexChange)="tabIndex = $event">
                <mat-tab>
                    <ng-template *ngIf="exibirGrid" [ngComponentOutlet]="componenteGrid.component"
                        [ndcDynamicInputs]="componenteGrid.inputs" [ndcDynamicOutputs]="componenteGrid.outputs">
                    </ng-template>
                    <ng-template mat-tab-label *ngIf="isLoading && (gridData || gridData?.length === 0)">
                        Resultados da busca &nbsp; <i class="fas fa-times" [matTooltip]="'Limpar pesquisa'"
                            (click)="clearFields()"></i>
                    </ng-template>
                </mat-tab>
                <mat-tab *ngFor="let tab of arrayAbas; let index = index" [label]="">
                    <ng-template [ngComponentOutlet]="tab.component" [ndcDynamicInputs]="tab.inputs"
                        [ndcDynamicOutputs]="tab.outputs">
                    </ng-template>
                    <ng-template mat-tab-label>
                        {{ tab.label }} &nbsp; <i class="fas fa-times" [matTooltip]="'Fechar aba'"
                            (click)="removerTab(index, $event)"></i>
                    </ng-template>
                </mat-tab>
            </mat-tab-group>
        </div>
    </section>
</div>
